import cn from 'classnames';
import { FC } from 'react';

import { ContentMobileBehavior, CtaVariant } from '@/shared/types';

import styles from './Row.module.scss';
import { Topic, TopicRow } from './Topic';

interface Props {
  topicsAsBoxes: boolean;
  topicsWithFourColumns?: boolean;
  topicBackgroundColorClassName: string;
  ctaVariant: CtaVariant;
  contentMobileBehavior: ContentMobileBehavior;
  topics: TopicRow[];
  locale: string;
}

export const Row: FC<Props> = ({
  locale,
  contentMobileBehavior,
  topicsAsBoxes,
  topicsWithFourColumns = false,
  topicBackgroundColorClassName,
  topics,
  ctaVariant,
}) => {
  const scroll = contentMobileBehavior === 'scroll';
  const swipe = contentMobileBehavior === 'swipe';

  return (
    <div
      className={cn({
        [styles.contentContainer]: scroll,
        [styles.contentContainerSwipable]: swipe,
        [styles.asBoxes]: topicsAsBoxes,
        [styles.fourColumns]: topicsWithFourColumns,
      })}
    >
      {topics.map((topic, index) => {
        const key = index;
        return (
          <Topic
            key={key}
            className={cn({
              [styles.contentSwipable]: swipe,
            })}
            backgroundColorClassName={topicBackgroundColorClassName}
            ctaVariant={ctaVariant}
            asBox={topicsAsBoxes}
            locale={locale}
            {...topic}
          />
        );
      })}
    </div>
  );
};
